import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { MessageEnum } from "../../../core/utils/message.enum";

@Component({
  selector: "app-script-duplicate-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./script-duplicate-modal.component.html",
  styleUrl: "./script-duplicate-modal.component.scss",
})
export class ScriptDuplicateModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  @Input()
  configs: any = {};

  isDisabled: boolean = true;
  errorMessage: string =
    "A script with this name already exists. Please enter a different name.";
  isLoading: boolean = false;
  placeholder: string = "";
  scriptName: string = "";
  selectedSuite: string = "";
  activeType: string = "keepIndividual";
  suites: any = [];
  isError: boolean = false;

  constructor(
    private restService: RestService,
    private toaster: ToasterService,
    private store: Store
  ) {}

  ngOnInit() {
    this.scriptName = this.configs.script?.name;
    // this.suites =
    //   this.configs.suites?.map((suite: any) => ({
    //     label: suite.name,
    //     value: suite.id,
    //   })) || [];

    //hide the current suite
    this.suites =
  this.configs.suites
    ?.filter((suite: any) => suite.name !== this.configs.suiteName)
    .map((suite: any) => ({
      label: suite.name,
      value: suite.id,
    })) || [];

  }

  onSelectChange() {}

  duplicateOrCopy() {
    this.isLoading = true;
    this.isError = false;
    let payload = {
      name: this.scriptName,
      automationGroupId:
        this.selectedSuite !== ""
          ? this.selectedSuite
          : this.configs?.type === "duplicate"
          ? this.configs?.script?.automationScriptGroup?.id
          : null,
    };
    if (!payload.automationGroupId) delete payload.automationGroupId;

    this.restService
      .duplicateScript(
        this.configs?.projectId,
        this.configs?.automationProjectId,
        this.configs?.script?.id,
        payload
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.isError = false;
          console.log(response);
          this.toaster.pop({
            type: "success",
            text:  this.configs?.type === "duplicate" ? MessageEnum.SCRIPT_DUPLICATE_SUCCESS :MessageEnum.SCRIPT_COPY_SUCCESS,
          });
          this.store.dispatch(
            AutomationActions.addTestScriptSuccess({
              testScript: response?.data,
            })
          );
          this.activeModal.close();
        },
        error: (error) => {
          this.isLoading = false;
          this.isError = true;
          this.errorMessage = error.message;
          console.error(error);
        },
      });
  }
}
